import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const useIsQVariant = (): boolean => {
  const router = useRouter()
  const asPath = router?.asPath || ''

  const detectQ = (pathname: string): boolean => {
    const parts = (pathname || '').split('/').filter(Boolean)
    return parts[0] === 'q' || parts[1] === 'q'
  }

  const [isQ, setIsQ] = useState(() => {
    if (typeof window !== 'undefined') {
      return detectQ(window.location.pathname)
    }
    return detectQ(asPath)
  })

  useEffect(() => {
    const update = () => setIsQ(detectQ(window.location.pathname))
    update()
    const handle = () => update()
    window.addEventListener('popstate', handle)
    return () => window.removeEventListener('popstate', handle)
  }, [])

  return isQ
}

export default useIsQVariant
